import { useSelector } from "react-redux";
import { useEffect, useState, useRef } from "react";
import classes from "./FadeOutOnLanguageChange.module.css";

export function FadeOnLanguageChange({ children }) {
  const { language } = useSelector((state) => state.global);
  const [fade, setFade] = useState(false);
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    setFade(true);

    const timer = setTimeout(() => {
      setFade(false);
    }, 300);

    return () => clearTimeout(timer);
  }, [language]);

  return (
    <div className={`${classes.fade} ${fade ? classes.out : ""}`}>
      {children}
    </div>
  );
}
